import { ComponentProps, memo } from 'react';
import { DeleteIcon } from '@/assets';
import { OutlinedButton } from '../OutlinedButton/OutlinedButton';
import { Button } from '@tremor/react';

interface Props extends Omit<ComponentProps<typeof Button>, 'icon'> {
  handleUserDelete: () => void;
}

export const RemoveUserButton = memo(function RemoveUserButton({
  handleUserDelete,
  ...rest
}: Props) {
  return (
    <OutlinedButton
      title="Remove User"
      icon={DeleteIcon}
      iconAltText="remove user icon"
      onClick={handleUserDelete}
      {...rest}
    >
      Remove
    </OutlinedButton>
  );
});
